/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachineGroups/Components/AddVirtualMachinesDetailsComponent" />
import * as React from "react";
import * as Resources from "Environments/ProviderCreateDetails/VirtualMachineGroups/Resources";

import { IVirtualMachinesProviderData } from "Environments/ProviderCreateDetails/VirtualMachineGroups/Utilities";
import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";

interface IAddVirtualMachinesProperties {
    instanceId: string;
    providerData: IVirtualMachinesProviderData;
    onProviderDataChange: (providerData: IVirtualMachinesProviderData, isValid: boolean) => void;
}

export class AddVirtualMachinesDetailsComponent extends React.Component<IAddVirtualMachinesProperties, {}> {

    public render(): JSX.Element {
        return (
            <FormItem label={Resources.ResourceName}>
                <TextField 
                    value={this.props.providerData.name}
                    onChange={this._onVMResourceNameChange}
                />
            </FormItem>
        );
    }

    private _onVMResourceNameChange = (event: any, value: string) => {
        let updatedProviderData = Object.assign({}, this.props.providerData, { name: value });
        this.props.onProviderDataChange(updatedProviderData, this._isValid(updatedProviderData));
    }

    private _isValid(data: IVirtualMachinesProviderData) {
        let valid = !!data.name;
        return valid;
    }
} 
